import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadCostCategorieService = async () => {
    try {
        const payload = {
            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1
        };

        return await callApi(API_ENDPOINTS.COSTING_GET_COSTING_CATEGORIES, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};


export const loadCostExpenseCategories = async (payload) => {
    try {
        return await callApi(API_ENDPOINTS.COSTING_GET_EXPENSES_CATEGORIES, 'POST', { 'Content-Type': 'application/json' }, payload);
    }
    catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
}